import React, { useEffect } from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import StockOutApprovalSearchAndFilterBar from './StockOutApprovalSearchAndFilterBar';
import StockOutApprovalTable from './StockOutApprovalTable';
import StockOutApprovalPaginator from './StockOutApprovalPaginator';
import ConfirmUpdateStockOutStatusModal from './ConfirmUpdateStockOutStatusModal';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

const StockOutApproval = () => {
    const dispatch = useAppDispatch();

    const stockOutListingIndex = useAppSelector(state => state.approval.pendingStockOutListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingStockOutListingAttempt());
    }, [stockOutListingIndex]);

    return (
        <TabPageContainer>
            <StockOutApprovalSearchAndFilterBar />

            <StockOutApprovalTable />

            <StockOutApprovalPaginator />

            <ConfirmUpdateStockOutStatusModal />
        </TabPageContainer>
    );
};

export default StockOutApproval;
